import React, { Component } from 'react';

export default class GLSApprover extends Component{
  constructor(props) {
    super(props);
    this.state = {
      title: 'All',
      display: 'none',
      arrowIsOpen : false
    }
  }

  _registerCloseEvent = () => {
    document.body.onclick = function(e) {
      if(this.state.display === 'block'){
        this._openHander(e);
      }
    }.bind(this);

    this._getStatusOnchange = this._getStatusOnchange.bind(this);
  }

  _openHander = (e) => {
      e.stopPropagation();
     if(this.state.arrowIsOpen === true && this.state.display === 'block'){
       this.setState({
         arrowIsOpen: false,
         display: 'none'
       })
     }else{
       this.setState({
         arrowIsOpen: true,
         display: 'block'
       })
     }
  }

  _clearStatus = () => {
      this.setState({
        title: this.props.text1
      });
  }

  handleWindowClick = () => {
    this.setState({
      display: 'none',
      arrowIsOpen: false
    });
  }

  componentWillUnmount(){
    window.removeEventListener('click', this.handleWindowClick);
  }

  componentDidMount(){
    window.addEventListener('click', this.handleWindowClick)
  }

  _getStatusOnchange (event){
  //event.stopPropagation();
      if(event.target.getAttribute("data-name")){
        this.setState({
          title: event.target.getAttribute("data-name")
        })
        this.props.getApproverStatusOnchange(event.target.getAttribute("data-name"));
        this._openHander(event);
    }
  }

  render(){

    const display = {
        display : this.state.display
    }

    return(
      <div className="gdoc-caselist-filter-dropcontainer">
        <div
          className="gdoc-addproduct-pdiv-lan status"
          onClick={(event)=>this._openHander(event)}
          tabIndex="0"
          role="list"
          data-dropdown="gdoc-addproduct-select-lng"
          aria-controls="gdoc-addproduct-select-lng"
          aria-expanded="false"
        >
          <span className="gdoc-addproduct-selected-country">
            <span className="gdoc-addproduct-plussign">{this.props.heading}</span>
            <span className="gdoc-addproduct-title">{this.state.title}</span>
          </span>
          <span className ="gdoc-addproduct-bar"> </span>
          <i className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up  gdoc-addproduct-icondown' : 'icon icon-chevron-down gdoc-addproduct-icondown' }></i>
        </div>
        <ul
          id="gdoc-addproduct-select-lng"
          className="gdoc-addproduct-custom-dropdown"
          style={display}
        >
        {
          this.props.caseStatus.length > 0
          ? Object.keys(this.props.caseStatus).map((key)=>  <li
              key={key}
              onClick={(event) => this._getStatusOnchange(event)}
              data-value={this.props.caseStatus[key].name}
              data-name={this.props.caseStatus[key].value}
            >
              {this.props.caseStatus[key].value}
            </li>)
          : ''
        }
        </ul>
      </div>
    )
  }
}

GLSApprover.defaultProps = {
caseStatus : []
}



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/Grid/GLSApprover.js